import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'

import useErrorNotifications from '@/queries/error_notification/useErrorNotifications'

const ErrorNotification = () => {
  const { data: errorNotifications } = useErrorNotifications()

  if (!errorNotifications || errorNotifications.length === 0) return null

  const notification = errorNotifications[0]

  return (
    <div className="fixed right-5 top-16 rounded-md bg-red-200 border border-red-500 p-4 z-[100] w-fit">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon aria-hidden="true" className="h-5 w-5 text-red-500" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-label-normal">{notification.content}</p>
        </div>
      </div>
    </div>
  )
}

export default ErrorNotification
